import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircleOutlined } from '@ant-design/icons';
import * as moment from 'moment';
import { LOCALES } from '../../i18n/index';
import 'moment/locale/es';
import 'moment/locale/fr';

import './styles.less';

const LogItem = ({ item }) => {
  moment.locale(localStorage.getItem('lang') || LOCALES.ENGLISH);
  const time = moment.unix(item.timestamp).utc(0).format('dddd, LT');
  return (
    <div className="item-wrapper" onClick={null}>
      <div className="data-wrapper">
        <div className="log-date">{time}</div>
        <div className="log-content">
          <span className="log-device-name">{item.data.device_name} </span>
          {item.data.details}
        </div>
      </div>
      <CheckCircleOutlined className="status-icon positive-check" />
    </div>
  );
};

LogItem.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default LogItem;
